import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_mst_entity_autodebit_txn_RowClass } from '../../../dbschema/bl_fi_mst_entity_autodebit_txn.model';

export class AutoDebitTxnContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_autodebit_txn: bl_fi_mst_entity_autodebit_txn_RowClass = new bl_fi_mst_entity_autodebit_txn_RowClass();
}
